export { AudioManager } from "./audio-manager";
export type { AudioEvent, AudioFormat } from "./audio-manager";

export interface AudioService {
  preload(ids: readonly string[]): Promise<void>;
  play(id: string): void;
  setMuted(muted: boolean): void;
}

// Haptics helper for web
export class HapticsManager {
  private enabled = true;
  private unlocked = false;

  unlock(): void {
    this.unlocked = true;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  light(): void {
    if (!this.enabled || !this.unlocked) return;
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  }

  medium(): void {
    if (!this.enabled || !this.unlocked) return;
    if (navigator.vibrate) {
      navigator.vibrate(25);
    }
  }

  heavy(): void {
    if (!this.enabled || !this.unlocked) return;
    if (navigator.vibrate) {
      navigator.vibrate([30, 10, 30]);
    }
  }
}
